import React, { useState, useEffect, useContext } from 'react'
import styles from './PagoRecurrente.module.css'

import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'
import * as PagoRecurrenteRepository from '../../services/repositories/pago-recurrente-repository'

const PagoCard = ({ state, setState, pago, producto, index, bloqueo, dataBloqueada }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)

  const [mediosPago, setMediosPago] = useState([])
  const [operadores, setOperadores] = useState([])

  useEffect(() => {
    const cargarCombo = async () => {
      setMediosPago(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 37))
    }

    const getObtenerOperadores = async () => {
        let codigo = 3
        if (((pago && pago.codigoTipoCobranza !== null) || pago.codigoTipoCobranza !== undefined)
          || (state.recurrente && state.recurrente[index].codigoTipoCobranza !== null)) {
          codigo = state.recurrente ? state.recurrente[index].codigoTipoCobranza : pago.codigoTipoCobranza
        }

        if (codigo === 3 || codigo === 4) {
          setState((state) => {
            return {
              ...state,
              estaCargando: false,
              errorCargando: null
            }
          })
        } else {
          await obtenerOperadores(codigo)
        }
    }

    cargarCombo().then(() => {
      getObtenerOperadores()
    })

  }, [state.recurrente])

  const obtenerOperadores = async (codigo) => {
    generalDispatch(GeneralActions.updateEstadoCargando(true))
    const response = await PagoRecurrenteRepository.obtenerOperadores(codigo)
    if (response.error === null) {
      if (codigo === 2) {
        setOperadores(response.operadores.filter(ope => ope.id !== 107))
      } else if (codigo === 1) {
        setOperadores(response.operadores)
      }
      generalDispatch(GeneralActions.updateEstadoCargando(false))
    } else {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
    }
  }

  function comboTipoCuenta(banco) {
    let combo = []

    if (banco === 1 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 1)[0].tipoCuentas
    }
    else if (banco === 2 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 2)[0].tipoCuentas
    }
    else if (banco === 4 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 4)[0].tipoCuentas
    }
    else if (banco === 21 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 21)[0].tipoCuentas
    }
    else if (banco === 23 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 23)[0].tipoCuentas
    }
    else if (banco === 37 && operadores.length > 0) {
      combo = operadores.filter(p => p.id === 37)[0].tipoCuentas
    }

    return combo
  }

  function traePlaceholderCuenta(tipo, cuenta) {
    let valor = ''

    if (tipo === 1 && (cuenta === 1 || cuenta === 2)) {
      valor = 'XXX-XXXXXXXX-X-XX'
    } else if (tipo === 1 && (cuenta === 3 || cuenta === 4 || cuenta === 5 || cuenta === 6)) {
      valor = 'XXX-XXXXXXX-X-XX'
    } else if (tipo === 1 && cuenta === 9) {
      valor = 'XXXX-XXXX-XXXX-XXXX'
    } else if (tipo === 1 && cuenta === 10) {
      valor = 'XXX-XXXXXXXXXX-X-XX'
    }

    else if (tipo === 2 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 'XXXX-XXXX-XXXXXXXXXX'
    }

    else if (tipo === 4 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 'XX-XXX-XXXXXXX'
    }

    else if (tipo === 21 && cuenta === 1) {
      valor = 'XXX-XXXXXXXXXX'
    }

    else if (tipo === 23 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 'XXX-XXXXXXXXXX'
    }

    else if (tipo === 37 && cuenta === 1) {
      valor = 'XXXXXXXXXXXX'
    }

    return valor
  }

  function traeLongitudTarjeta(tipo) {
    let valor = 0
    if (tipo === 101 || tipo === 102 || tipo === 107) {
      valor = 19
    }
    else if (tipo === 103) {
      valor = 17
    }
    else if (tipo === 104) {
      valor = 16
    }
    return valor
  }

  function traeLongitudCuenta(tipo, cuenta) {
    let valor = 0
    if (tipo === 1 && (cuenta === 1 || cuenta === 2)) {
      valor = 17
    } else if (tipo === 1 && (cuenta === 3 || cuenta === 4 || cuenta === 5 || cuenta === 6)) {
      valor = 16
    } else if (tipo === 1 && cuenta === 9) {
      valor = 19
    } else if (tipo === 1 && cuenta === 10) {
      valor = 19
    }

    else if (tipo === 2 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 20
    }

    else if (tipo === 4 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 14
    }

    else if (tipo === 21 && cuenta === 1) {
      valor = 14
    }

    else if (tipo === 23 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      valor = 14
    }

    else if (tipo === 37 && cuenta === 1) {
      valor = 12
    }

    return valor
  }

  const handleTipoCobranza = async (e, campo) => {
    let codigo = parseInt(e.target.value)
    if (codigo !== 3) {
      obtenerOperadores(codigo)
    }

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (indexPago === index) {
        pagoAux = {
          ...pagoAux,
          [campo]: codigo,
          codigoOperadorTarjeta: 0,
          numeroTarjeta: null,
          codigoTipoCuenta: 0,
          fechaVencimiento: ''
        }

      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.medioPago = true
        campoAux.bancoEntidad = true
        campoAux.tipoCuenta = true
        campoAux.numeroCuenta = true
        campoAux.operadorTarjeta = true
        campoAux.numeroTarjeta = true
        campoAux.fechaVencimiento = true
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.medioPago = ''
        mensajeAux.tipoBanco = ''
        mensajeAux.tipoCuenta = ''
        mensajeAux.numeroCuenta = ''
        mensajeAux.tipoTarjeta = ''
        mensajeAux.numeroTarjeta = ''
        mensajeAux.vencimiento = ''
      }
      return mensajeAux
    })

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes
      }
    })
  }

  const handleTipoOperador = (e, campo) => {
    let valor = ''
    let codigo = parseInt(e.target.value)

    if (codigo === 101 || codigo === 107) {
      valor = '4'
    } else if (codigo === 102) {
      valor = '5'
    } else if (codigo === 103 || codigo === 104) {
      valor = '3'
    }

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (indexPago === index) {
        pagoAux = {
          ...pagoAux,
          [campo]: codigo,
          numeroTarjeta: valor,
          codigoTipoCuenta: 0,
          fechaVencimiento: ''
        }
      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.bancoEntidad = true
        campoAux.operadorTarjeta = true
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.tipoBanco = ''
        mensajeAux.tipoTarjeta = ''
      }
      return mensajeAux
    })

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes
      }
    })
  }

  const handleTipoCuenta = (e, campo, operador) => {
    let codigo = parseInt(e.target.value)
    let valor = ''

    if (operador === 4 && codigo === 1) {
      valor = '14'
    } else if (operador === 4 && codigo === 2) {
      valor = '83'
    } else if (operador === 4 && codigo === 3) {
      valor = '01'
    } else if (operador === 4 && codigo === 4) {
      valor = '07'
    }
    else if (operador === 21 && codigo === 1) {
      valor = '0000'
    }
    else if (operador === 2 && (codigo === 1 || codigo === 2 || codigo === 3 || codigo === 4)) {
      valor = '0011'
    }

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (indexPago === index) {
        pagoAux = {
          ...pagoAux,
          [campo]: codigo,
          numeroTarjeta: valor
        }
      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.tipoCuenta = true
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.tipoCuenta = ''
      }
      return mensajeAux
    })

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes
      }
    })
  }

  const handleChangeNumeroTarjeta = (e, campo, tipo) => {
    let valor = e.target.value
    let mostrar = ''
    let regex = /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g
    let regex2 = /^(\d{0,4})(\d{0,6})(\d{0,5})$/g
    let regex3 = /^(\d{0,4})(\d{0,6})(\d{0,4})$/g
    let onlyNumbers = valor.replace(/[^\d]/g, '')
    let valTarjetaVisa = true

    if (tipo === 101 || tipo === 102 || tipo === 107) {
      let final = onlyNumbers.replace(regex, (regex, $1, $2, $3, $4) =>
        [$1, $2, $3, $4].filter(group => !!group).join('-'))
      mostrar = final
    }
    else if (tipo === 103) {
      let final2 = onlyNumbers.replace(regex2, (regex2, $1, $2, $3) =>
        [$1, $2, $3].filter(group => !!group).join('-'))
      mostrar = final2
    }
    else if (tipo === 104) {
      let final3 = onlyNumbers.replace(regex3, (regex3, $1, $2, $3) =>
        [$1, $2, $3].filter(group => !!group).join('-'))
      mostrar = final3
    }

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (indexPago === index) {
        pagoAux = {
          ...pagoAux,
          [campo]: mostrar
        }
      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.numeroTarjeta = true
      }
      if (tipo === 101 && onlyNumbers.length === 16) {
        valTarjetaVisa = validarTarjetaVisa(onlyNumbers);
        campoAux.numeroTarjeta = valTarjetaVisa;
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.numeroTarjeta = ''
      }
      if (tipo === 101 && onlyNumbers.length === 16) {
        if (!valTarjetaVisa) {
          mensajeAux.numeroTarjeta = 'Tarjeta inválida';
        }

      }
      return mensajeAux
    })

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes
      }
    })
  }

  const handleChangeNumeroCuenta = (e, campo, tipo, cuenta) => {
    let valor = e.target.value
    let mostrar = ''
    let bcp = /^(\d{0,3})(\d{0,8})(\d{0,1})(\d{0,2})$/g
    let bcp_ahorros = /^(\d{0,3})(\d{0,7})(\d{0,1})(\d{0,2})$/g
    let bcp2 = /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g
    let bcp3 = /^(\d{0,3})(\d{0,10})(\d{0,1})(\d{0,2})$/g
    let continental = /^(\d{0,4})(\d{0,4})(\d{0,10})$/g
    let scotiabank = /^(\d{0,2})(\d{0,3})(\d{0,7})$/g
    let financiero = /^(\d{0,3})(\d{0,10})$/g
    let interbank = /^(\d{0,3})(\d{0,10})$/g
    let onlyNumbers = valor.replace(/[^\d]/g, '')

    if (tipo === 1 && (cuenta === 1 || cuenta === 2)) {
      let final = onlyNumbers.replace(bcp, (bcp, $1, $2, $3, $4) =>
        [$1, $2, $3, $4].filter(group => !!group).join('-'))
      mostrar = final
    } else if (tipo === 1 && (cuenta === 3 || cuenta === 4 || cuenta === 5 || cuenta === 6)) {
      let final = onlyNumbers.replace(bcp_ahorros, (bcp_ahorros, $1, $2, $3, $4) =>
        [$1, $2, $3, $4].filter(group => !!group).join('-'))
      mostrar = final
    } else if (tipo === 1 && cuenta === 9) {
      let final = onlyNumbers.replace(bcp2, (bcp2, $1, $2, $3, $4) =>
        [$1, $2, $3, $4].filter(group => !!group).join('-'))
      mostrar = final
    } else if (tipo === 1 && cuenta === 10) {
      let final = onlyNumbers.replace(bcp3, (bcp3, $1, $2, $3, $4) =>
        [$1, $2, $3, $4].filter(group => !!group).join('-'))
      mostrar = final
    }

    else if (tipo === 2 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      let final = onlyNumbers.replace(continental, (continental, $1, $2, $3) =>
        [$1, $2, $3].filter(group => !!group).join('-'))
      mostrar = final
    }

    else if (tipo === 4 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      let final = onlyNumbers.replace(scotiabank, (scotiabank, $1, $2, $3) =>
        [$1, $2, $3].filter(group => !!group).join('-'))
      mostrar = final
    }

    else if (tipo === 21 && cuenta === 1) {
      let final = onlyNumbers.replace(financiero, (financiero, $1, $2) =>
        [$1, $2].filter(group => !!group).join('-'))
      mostrar = final
    }

    else if (tipo === 23 && (cuenta === 1 || cuenta === 2 || cuenta === 3 || cuenta === 4)) {
      let final = onlyNumbers.replace(interbank, (interbank, $1, $2) =>
        [$1, $2].filter(group => !!group).join('-'))
      mostrar = final
    }

    else if (tipo === 37 && cuenta === 1) {
      mostrar = onlyNumbers
    }

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (indexPago === index) {
        pagoAux = {
          ...pagoAux,
          [campo]: mostrar
        }
      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.numeroCuenta = true
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.numeroCuenta = ''
      }
      return mensajeAux
    })

    let camposVal = state.camposModificados !== undefined ? state.camposModificados : {[campo]: []}
    camposVal[campo][producto.moneda === 'Dolares' ? Constantes.COD_MONEDA_DOLARES : Constantes.COD_MONEDA_SOLES] = true

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes,
        camposModificados: camposVal
      }
    })
  }

  const handleChangeFecha = (e, campo) => {
    let valor = e.target.value.replace(/[^0-9]/g, '')
      .replace(/^([2-9])$/g, '0$1')
      .replace(/^(1{1})([3-9]{1})$/g, '0$1/$2')
      .replace(/^0{1,}/g, '0')
      .replace(/^([0-1]{1}[0-9]{1})([0-9]{1,4}).*/g, '$1/$2')

    let pagos = state.pago.map((pagoAux, indexPago) => {
      if (index === indexPago) {
        pagoAux = {
          ...pagoAux,
          [campo]: valor
        }
      }
      return pagoAux
    })

    let campos = state.campoValidado.map((campoAux, indexCampo) => {
      if (index === indexCampo) {
        campoAux.fechaVencimiento = true
      }
      return campoAux
    })

    let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
      if (index === indexMensaje) {
        mensajeAux.vencimiento = ''
      }
      return mensajeAux
    })

    setState((state) => {
      return {
        ...state,
        pago: pagos,
        campoValidado: campos,
        mensajes: mensajes
      }
    })
  }

  const validarTarjetaVisa = (numeroTarjeta) => {

    let arrNVisa = [...numeroTarjeta]
    let ultimoDigito = arrNVisa[arrNVisa.length - 1]
    arrNVisa.pop()
    let argNumero = [2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2]
    let sumaTotal = 0
    let suma1 = 0
    let suma2 = 0
    let residuo = 0
    let entero = 0
    let resultado = 0
    let rstFinal = 0
    let ret = false

    arrNVisa.forEach(function (elemento, indice) {

      let numero = parseInt(argNumero[indice])
      let producto = (elemento * numero)
      let extrae = producto.toString().substring(2, 1)

      suma1 += producto >= 10 ? 1 : producto
      suma2 += producto > 10 ? parseInt(extrae) : 0

    })

    sumaTotal = suma1 + suma2
    residuo = sumaTotal % 10
    entero = Math.trunc(sumaTotal / 10)
    resultado = 10 * (residuo === 0 ? entero : entero + 1)
    rstFinal = resultado - sumaTotal
    ret = (rstFinal === parseInt(ultimoDigito)) ? true : false

    return ret
  }

  return (
    <React.Fragment key={index}>
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div className={styles['area25']}>
          <label>Producto</label>
          <input
            type='text'
            value={(producto && producto.moneda === 'Dolares') ?
              'Mis Productos   (US$)' : (producto && producto.moneda === 'Soles') ?
                'Mis Productos   (S/)' : ''}
            disabled
          />
        </div>
        <div className={styles['area25']}>
          <label>Frecuencia de pago</label>
          <input
            type='text'
            value={producto ? producto.frecuenciaPago : ''}
            disabled
          />
        </div>
        <div className={styles['area25']}>
          <label>Prima total</label>
          <input
            type='text'
            value={(producto) ? parseFloat(producto.primaTotal).toFixed(2) : ''}
            disabled
          />
        </div>
        <div className={styles['area25']}>
          <label>Medio de pago{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <select
            className={(state.campoValidado[index] && !state.campoValidado[index].medioPago) ? styles['error-input'] : null}
            type='text'
            value={((state.recurrente && state.recurrente[index].codigoTipoCobranza) || 0)
              || ((pago && pago.codigoTipoCobranza) || 0)}
            onChange={(e) => handleTipoCobranza(e, 'codigoTipoCobranza')}
            disabled={bloqueo || dataBloqueada}
          >
            <option value={0}>Seleccione</option>
            {(producto && producto.frecuenciaPago === 'Mensual') ?
              (mediosPago.filter(medio => medio.id === 1 || medio.id === 2).map(medio => (
                <option key={medio.id} value={medio.id}>
                  {medio.valor}
                </option>))) :
              (mediosPago.map(medio => (
                <option key={medio.id} value={medio.id}>
                  {medio.valor}
                </option>)))
            }
          </select>{' '}
          {!state.campoValidado[index].medioPago && (
            <span className={styles['error']}>{state.mensajes[index] && state.mensajes[index].cobranza}</span>
          )}
        </div>
      </div>
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div className={styles['area25']}>
        {/*OPERADOR DE TARJETA - ENTIDAD FINANCIERA*/}
          {((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ? 
              <label>
                Operador de tarjeta{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : ((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <label>
                Banco/Entidad financiera{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : null
          }
          {((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ? 
              <select
                className={(state.campoValidado[index] && !state.campoValidado[index].operadorTarjeta) ? styles['error-input'] : null}
                type='text'
                value={((state.recurrente && state.recurrente[index].codigoOperadorTarjeta) || 0) || ((pago.codigoOperadorTarjeta) || 0)}
                onChange={(e) => handleTipoOperador(e, 'codigoOperadorTarjeta')}
                disabled={bloqueo || dataBloqueada}
              >
                <option value={0}>Seleccione</option>
                {operadores !== null ? operadores.map(medio => (
                  <option key={medio.id} value={medio.id}>
                    {medio.valor}
                  </option>
                )) : null}
              </select>
            : ((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <select
                className={(state.campoValidado[index] && !state.campoValidado[index].bancoEntidad) ? styles['error-input'] : null}
                type='text'
                value={((state.recurrente && state.recurrente[index].codigoOperadorTarjeta) || 0) || ((pago && pago.codigoOperadorTarjeta) || 0)}
                onChange={(e) => handleTipoOperador(e, 'codigoOperadorTarjeta')}
                disabled={bloqueo || dataBloqueada}
              >
                <option value={0}>Seleccione</option>
                {operadores !== null ? operadores.map(medio => (
                  <option key={medio.id} value={medio.id}>
                    {medio.valor}
                  </option>
                )) : null}
              </select>
            : null
          }
          {/*mensaje de obligatoriedad */}
          {(pago && pago.codigoTipoCobranza === 2)
            ? !state.campoValidado.operadorTarjeta && (
              <span className={styles['error']}>
                {state.mensajes[index] && state.mensajes[index].tipoTarjeta}
              </span>
            )
            : null}
          {(pago && pago.codigoTipoCobranza === 1)
            ? !state.campoValidado.bancoEntidad && (
              <span className={styles['error']}>
                {state.mensajes[index] && state.mensajes[index].tipoBanco}
              </span>
            )
            : null}
        </div>
        <div className={styles['area25']}>
        {/*NÚMERO DE TARJETA - TIPO DE CUENTA*/}
          {((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ? 
              <label>
                Número de tarjeta {Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : ((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <label>
                Tipo de cuenta{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : null
          }
          {((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <select
                className={(state.campoValidado[index] && !state.campoValidado[index].tipoCuenta) ? styles['error-input'] : null}
                type='text'
                value={((state.recurrente && state.recurrente[index].codigoTipoCuenta) || 0) || ((pago && pago.codigoTipoCuenta) || 0)}
                onChange={(e) => handleTipoCuenta(e, 'codigoTipoCuenta', (pago && pago.codigoOperadorTarjeta))}
                disabled={bloqueo || dataBloqueada}
              >
                <option value={0}>Seleccione</option>
                {comboTipoCuenta(((state.recurrente && state.recurrente[index].codigoOperadorTarjeta) || (pago && pago.codigoOperadorTarjeta))) !== undefined ?
                  comboTipoCuenta(((state.recurrente && state.recurrente[index].codigoOperadorTarjeta) || (pago && pago.codigoOperadorTarjeta)))
                    .map(cuenta => (
                      <option key={cuenta.id} value={cuenta.id}>
                        {cuenta.descripcion}
                      </option>
                    )) : ''}
              </select>
            : ((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ?
              <input
                maxLength={traeLongitudTarjeta((pago && pago.codigoOperadorTarjeta))}
                //CMUNAYLLA: se muestra '*' para el numero de tarjeta cuando ya ha sido registrado
                value={state.recurrente ? '*************' : pago.numeroTarjeta ? pago.numeroTarjeta : ''}
                /*(state.recurrente && state.recurrente[index].numeroTarjeta.length !== null) ? 
                  enmascararTarjeta(state.recurrente[index].numeroTarjeta, state.recurrente[index].codigoOperadorTarjeta) 
                : pago.numeroTarjeta ? pago.numeroTarjeta : ''}*/
                className={(state.campoValidado[index] && !state.campoValidado[index].numeroTarjeta) ? styles['error-input'] : null}
                onChange={(e) => handleChangeNumeroTarjeta(e, 'numeroTarjeta', (pago && pago.codigoOperadorTarjeta))}
                disabled={bloqueo || dataBloqueada}
                autoComplete="cc-csc"
              />
            : null
          }
          {(pago && pago.codigoTipoCobranza === 2) ? (
            !state.campoValidado.numeroTarjeta ? (
              <span className={styles['error']}>{state.mensajes[index] && state.mensajes[index].numeroTarjeta}</span>
            ) : null
          ) : null}
          {(pago && pago.codigoTipoCobranza === 1) ? (
            !state.campoValidado.tipoCuenta ? (
              <span className={styles['error']}>{state.mensajes[index] && state.mensajes[index].tipoCuenta}</span>
            ) : null
          ) : null}
        </div>
        <div className={styles['area25']}>
        {/*FECHA DE VENCIMIENTO - NÚMERO DE CUENTA*/}
          {((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ?
              <label>
                Fecha de vencimiento{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : ((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <label>
                Número de cuenta{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
              </label>
            : null
          }
          {((pago && pago.codigoTipoCobranza === 2) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 2)) ?
              <input
                //CMUNAYLLA: se muestra '*' para la fecha de vencimiento cuando ya ha sido registrado
                value={state.recurrente ? '******' : pago.fechaVencimiento ? pago.fechaVencimiento : ''}
                /*{state.recurrente ? enmascaraFecha(state.recurrente[index].fechaVencimiento) : pago.fechaVencimiento ? pago.fechaVencimiento : ''}*/
                type='text'
                placeholder={'MM/YYYY'}
                maxLength={7}
                className={(state.campoValidado[index] && !state.campoValidado[index].fechaVencimiento) ? styles['error-input'] : null}
                onChange={(e) => handleChangeFecha(e, 'fechaVencimiento')}
                disabled={bloqueo || dataBloqueada}
                autoComplete="cc-csc"
              />
            : ((pago && pago.codigoTipoCobranza === 1) || (state.recurrente && state.recurrente[index].codigoTipoCobranza === 1)) ?
              <input
                type='text'
                maxLength={traeLongitudCuenta((pago && pago.codigoOperadorTarjeta), (pago && pago.codigoTipoCuenta))}
                placeholder={traePlaceholderCuenta((pago && pago.codigoOperadorTarjeta), (pago && pago.codigoTipoCuenta))}
                //CMUNAYLLA: se muestra '*' para el numero de tarjeta cuando ya ha sido registrado
                value={state.recurrente ? '*******************' : pago.numeroTarjeta ? pago.numeroTarjeta : ''}
                className={((state.campoValidado[index] && !state.campoValidado[index].numeroCuenta) || (producto.moneda === state.codMonedaError))
                  ? styles['error-input'] : null}
                onChange={(e) =>
                  handleChangeNumeroCuenta(e, 'numeroTarjeta', (pago && pago.codigoOperadorTarjeta), (pago && pago.codigoTipoCuenta))
                }
                disabled={bloqueo || dataBloqueada}
                autoComplete="cc-csc"
              />
            : null
          }
          {(pago && pago.codigoTipoCobranza === 2)
            ? !state.campoValidado.fechaVencimiento && (
              <span className={styles['error']}>
                {state.mensajes[index] && state.mensajes[index].vencimiento}
              </span>
            )
            : null}
          {(pago && pago.codigoTipoCobranza === 1)
            ? !state.campoValidado.numeroCuenta && (
              <span className={styles['error']}>{state.mensajes[index] && state.mensajes[index].numeroCuenta}</span>
            )
            : null}
        </div>
        <div className={styles['area25']}></div>
      </div>
    </React.Fragment>
  )
}

export default PagoCard